export interface DisplayIaChatbotInterfaceState {
  iaChatbotUrl: string|null;
}

export const initialDisplayIaChatbotInterfaceState: DisplayIaChatbotInterfaceState = {
  iaChatbotUrl: null
};
